import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

export interface DropdownOption {
  id: any;
  name: string;
  icon?: string; // path to image (e.g. 'assets/icons/soil_pin.png')
}

@Component({
  selector: 'ui-dropdown',
  templateUrl: './dropdown.component.html',
  standalone: false
})
export class UiDropdownComponent {
  @Input() label = '';
  @Input() placeholder = 'Select...';
  @Input() options: DropdownOption[] = [];
  @Input() value: any = null;
  @Input() searchable = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<any>();

  open = false;
  search = '';

  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocClick(e: Event) {
    if (!this.el.nativeElement.contains(e.target)) this.open = false;
  }

  get selectedLabel(): string {
    const opt = this.options.find(o => o.id === this.value);
    return opt?.name || '';
  }

  get selectedIcon(): string | undefined {
    const opt = this.options.find(o => o.id === this.value);
    return opt?.icon;
  }

  get filtered(): DropdownOption[] {
    if (!this.searchable || !this.search) return this.options;
    const s = this.search.toLowerCase();
    return this.options.filter(o => o.name.toLowerCase().includes(s));
  }

  toggle(): void {
    if (this.disabled) return;
    this.open = !this.open;
    this.search = '';
    if (this.open && this.searchable) {
      setTimeout(() => {
        const input = this.el.nativeElement.querySelector('.ui-dropdown-search');
        if (input) input.focus();
      });
    }
  }

  select(option: DropdownOption): void {
    this.value = option.id;
    this.valueChange.emit(option.id);
    this.open = false;
  }

  selectFirst(): void {
    if (this.filtered.length > 0) {
      this.select(this.filtered[0]);
    }
  }
}
